module.exports = __webpack_public_path__ + "static/1-6a4bbe7e21a6d799a225e1730ef89d13.jpg";